import React from "react";
import { AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LangContext";

const T = {
  sk: {
    label: "Upozornenie · Disclaimer",
    body: (
      <>
        Vypočítané hodnoty sú <strong>orientačné</strong> a slúžia ako východiskový bod pre nastavenie zváracieho zariadenia.
        Nezaručujú 100% kvalitu zvaru ani úplnú zhodu s normami EN ISO 9606 / EN 287.{" "}
        <strong className="text-amber-300">
          Tigik je nezávislý nástroj — nemáme nič spoločné s výrobcami zváracích strojov uvedenými v aplikácii,
          nie sme s nimi obchodne, kapitálovo ani inak prepojení.
        </strong>{" "}
        Názvy strojov sú použité výhradne na technickú identifikáciu kompatibility.
        Vždy si overte program skúšobným zvarom a vykonajte potrebné zmeny v nastavení.
        Doladnite podľa konkrétneho materiálu, vlhkosti, polohy zvárania a stavu zariadenia.
        Nezodpovedáme za správnosť, legálnosť ani bezpečnosť programov a dát vložených alebo zdieľaných tretími stranami (používateľmi).
        Za výsledný zvar a možné chyby zodpovedá vykonávajúci zvárač/montér.
      </>
    ),
  },
  en: {
    label: "Disclaimer",
    body: (
      <>
        Calculated values are <strong>indicative</strong> and serve as a starting point for setting up the welding equipment.
        They do not guarantee 100% weld quality or full compliance with EN ISO 9606 / EN 287.{" "}
        <strong className="text-amber-300">
          Tigik is an independent tool — we are not affiliated with the welding machine manufacturers mentioned in the app,
          and have no business, capital or other relationship with them.
        </strong>{" "}
        Brand names are used solely for technical compatibility identification.
        Always validate the program on a test coupon and adjust the settings as needed.
        Fine-tune according to the specific material, humidity, welding position and equipment condition.
        We are not liable for the correctness, legality or safety of programs and data submitted or shared by third parties (users).
        The final weld and any defects are the responsibility of the executing welder/fitter.
      </>
    ),
  },
  cs: {
    label: "Upozornění · Disclaimer",
    body: (
      <>
        Vypočítané hodnoty jsou <strong>orientační</strong> a slouží jako výchozí bod pro nastavení svařovacího zařízení.
        Nezaručují 100% kvalitu svaru ani úplnou shodu s normami EN ISO 9606 / EN 287.{" "}
        <strong className="text-amber-300">
          Tigik je nezávislý nástroj — nemáme nic společného s výrobci svařovacích strojů uvedenými v aplikaci,
          nejsme s nimi obchodně, kapitálově ani jinak propojeni.
        </strong>{" "}
        Názvy strojů jsou použity výhradně pro technickou identifikaci kompatibility.
        Vždy si program ověřte zkušebním svarem a proveďte potřebné změny v nastavení.
        Dolaďte podle konkrétního materiálu, vlhkosti, polohy svařování a stavu zařízení.
        Neodpovídáme za správnost, legálnost ani bezpečnost programů a dat vložených či sdílených třetími stranami (uživateli).
        Za výsledný svar a případné vady odpovídá provádějící svářeč/montér.
      </>
    ),
  },
  de: {
    label: "Hinweis · Disclaimer",
    body: (
      <>
        Die berechneten Werte sind <strong>Richtwerte</strong> und dienen als Ausgangspunkt für die Einrichtung der Schweißanlage.
        Sie garantieren keine 100% Schweißqualität und keine vollständige Konformität mit EN ISO 9606 / EN 287.{" "}
        <strong className="text-amber-300">
          Tigik ist ein unabhängiges Werkzeug — wir sind mit den in der App genannten Schweißmaschinenherstellern
          weder geschäftlich, kapitalmäßig noch in sonstiger Weise verbunden.
        </strong>{" "}
        Markennamen werden ausschließlich zur technischen Kompatibilitätskennzeichnung verwendet.
        Validieren Sie das Programm immer an einem Probestück und passen Sie die Einstellungen entsprechend an.
        Feinjustierung nach Material, Luftfeuchtigkeit, Schweißposition und Anlagenzustand.
        Wir haften nicht für die Richtigkeit, Rechtmäßigkeit oder Sicherheit von Programmen und Daten,
        die von Dritten (Benutzern) eingegeben oder geteilt werden.
        Für die fertige Schweißnaht und etwaige Fehler haftet der ausführende Schweißer/Monteur.
      </>
    ),
  },
  pl: {
    label: "Uwaga · Disclaimer",
    body: (
      <>
        Obliczone wartości mają <strong>charakter orientacyjny</strong> i służą jako punkt wyjścia do ustawień maszyny spawalniczej.
        Nie gwarantują 100% jakości spoiny ani pełnej zgodności z normami EN ISO 9606 / EN 287.{" "}
        <strong className="text-amber-300">
          Tigik to niezależne narzędzie — nie jesteśmy powiązani z producentami maszyn spawalniczych wymienionymi w aplikacji
          ani biznesowo, ani kapitałowo, ani w żaden inny sposób.
        </strong>{" "}
        Nazwy maszyn są używane wyłącznie w celu identyfikacji kompatybilności technicznej.
        Zawsze zweryfikuj program na próbce testowej i dostosuj ustawienia w razie potrzeby.
        Dostrój parametry zgodnie z konkretnym materiałem, wilgotnością, pozycją spawania i stanem urządzenia.
        Nie ponosimy odpowiedzialności za poprawność, legalność ani bezpieczeństwo programów i danych wprowadzonych lub udostępnionych przez osoby trzecie (użytkowników).
        Za końcową spoinę i ewentualne wady odpowiada wykonujący spawacz/monter.
      </>
    ),
  },
  fr: {
  label: "Avertissement · Disclaimer",
  body: (
    <>
      Les valeurs calculées sont <strong>indicatives</strong> et servent de point de départ pour le réglage de l'équipement de soudage.
      Elles ne garantissent ni une qualité de soudure à 100% ni une conformité totale aux normes EN ISO 9606 / EN 287.{" "}
      <strong className="text-amber-300">
        Tigik est un outil indépendant — nous n'avons aucun lien avec les fabricants de machines à souder mentionnés dans l'application,
        nous ne sommes liés à eux ni commercialement, ni financièrement, ni d'une autre manière.
      </strong>{" "}
      Les noms de machines sont utilisés uniquement pour l'identification technique de compatibilité.
      Vérifie toujours le programme par un cordon d'essai et effectue les ajustements nécessaires.
      Affine selon le matériau spécifique, l'humidité, la position de soudage et l'état de l'équipement.
      Nous ne sommes pas responsables de l'exactitude, de la légalité ni de la sécurité des programmes et données saisis ou partagés par des tiers (utilisateurs).
      Le soudeur/monteur exécutant est responsable du cordon final et des éventuelles défaillances.
    </>
  ),
},
};

/**
 * Disclaimer shown under every calculator output.
 * Communicates that values are advisory + Tigik is NOT affiliated with welding machine manufacturers.
 * Fully localized in SK / EN / CS / DE / PL.
 */
export default function CalcDisclaimer({ extra = null }) {
  const { lang } = useLang() || { lang: "sk" };
  const t = T[lang] || T.sk;
  return (
    <div
      data-testid="calc-disclaimer"
      className="border-l-2 border-amber-500 bg-amber-500/5 p-3 flex items-start gap-3 text-xs"
    >
      <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" strokeWidth={2} />
      <div className="text-zinc-300 leading-relaxed">
        <span className="font-bold text-amber-400 uppercase tracking-wider text-[10px] font-mono block mb-1">
          {t.label}
        </span>
        {t.body}
        {extra && <span className="block mt-1 text-zinc-400">{extra}</span>}
      </div>
    </div>
  );
}
